module.exports = __webpack_public_path__ + "img/x9.89d4bfa6.jpg";